import constants from '../constants'

const initialState = {
  resStatus: false,
  resMessage: '',
  userList: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.USER_LIST:
      return {
        ...state,
        userList: action.payload.data,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.ADD_ADMIN_USER:
      return {
        ...state,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.UPDATE_USER:
      return {
        ...state,
        userDetails: action.payload.data,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    default:
      return state
  }
}
